import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAustrianPost = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 32,
		height: 32,
		rx: 16,
		fill: "#FFDD00"
	}), /* @__PURE__ */ _jsx("g", {
		transform: "translate(6 10.95) scale(0.4295)",
		fill: "#231F20",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", { d: "M4.877 8.964 1.097 2.312s-.156-.217-.025-.48.056-.225.479-.211h7.092s-2.967 2.86-3.766 7.343M11.462.578 1.695.566S.608.51.191 1.256s-.509.791.135 1.843L5.662 12.47s-.746-7.281 5.8-11.894M44.958 2.646C43.916 3.845 37.065 11.724 34.523 14.349 29.082 19.969 24.397 22.476 19.335 22.476c-5.904 0-10.706-4.806-10.706-10.714 0-5.907 4.802-10.712 10.706-10.712 2.596 0 5.525 1.499 7.446 3.068L23.695 8.413c-1.447-1.832-3.237-2.124-4.345-2.145-1.425-.028-2.847.57-3.903 1.636-1.061 1.074-1.645 2.511-1.604 3.947.087 2.977 2.552 5.4 5.497 5.4 2.973 0 4.431-2.04 5.718-3.844l.53-.727C26.137 11.945 32.04 3.67 33.487 1.643h11.523c.152 0 .311.097.325.277.011.159.03.271-.38.72zm-12.014-2.051c-.075.106-7.589 10.644-8.196 11.456l-.544.748C22.955 14.55 21.773 16.203 19.34 16.203c-2.384 0-4.379-1.968-4.45-4.384-.033-1.149.442-2.306 1.303-3.178.857-.863 1.998-1.347 3.135-1.325 1.044.02 2.964.383 4.083 2.593l.18.377 4.568-6.386C26.175 2.045 22.541 0 19.335 0 12.852 0 7.58 5.275 7.58 11.763c0 6.486 5.272 11.763 11.755 11.763 6.959 0 12.431-4.822 15.941-8.447C38.033 12.229 45.81 3.266 45.887 3.176c.681-.853.508-1.529.393-1.791C46.073.905 45.601.609 45.04.598H32.958z" })
	})]
});
export default SvgAustrianPost;
